
<div class="container mt-4 mb-4">
    <div class="row h-100 justify-content-center align-items-center">
        <div class="col-12">
            <mat-card class="req-card">
                <mat-card-header>
                    <div class="w-100">
                        <mat-card-title class="m-0">
                            <div class="container">
                                <div class="row justify-content-center ">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 logo">
                                        <div style="margin-top:12px;">
                                            <img class="mt-1" src="../../../../../Scripts/libs/assets/Images/Hyundai_White.png">
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
                                        <h5 id="appTitle" color="primary" style="margin-top:12px;">Hyundai Motor Company Australia Pty Ltd <span *ngIf="defaultValues">
                                          {{ url == routerConstants.Stocktake ? 'Stocktake ' : 'FBT Declaration ' }} ({{defaultValues.CurrentFinancialYear}})
                                        </span></h5>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 text-right"></div>
                                </div>
                            </div>
                            <!--Hyundai Motor Company Australia Pty Ltd Stocktake <span *ngIf="defaultValues"> ( {{defaultValues.CurrentFinancialYear}} )</span>-->

                        </mat-card-title>
                    </div>
                </mat-card-header>
                <mat-card-content>
                    <div class="container-fluid">
                        <form *ngIf="isFormReady" [formGroup]="stocktakeForm" #formDirective="ngForm"
                              autocomplete="off">
                            <div class="row text-primary mt-3">
                                <div class="col-lg-10 col-md-10 col-sm-10 col-xs-12">
                                    DECLARATION OF COMPANY VEHICLE POSSESSION
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 currentDate">
                                    {{stocktakeForm.get('Date').value | date:'dd/MM/yyyy'}}
                                </div>
                            </div>
                            <div class="row mt-3">

                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <label class="required pr-1 request-type-text req-lbl">
                                        <span>
                                            User Type
                                        </span>
                                        <span class="required-symbol pr-1 mat-placeholder-required">
                                            *
                                        </span>
                                    </label>

                                    <mat-radio-group required
                                                     formControlName="UserType"
                                                     style="top:-5px !important"
                                                     (change)="onUserTypeChange()">
                                        <!--<mat-radio-button [value]="appConstants.hmca">
                                            <span class="pr-2" style="position: relative;top: 2px;">
                                                HMCA
                                            </span>
                                        </mat-radio-button>-->
                                        <mat-radio-button [value]="appConstants.other">
                                            <span class="pr-2" style="position: relative;top: 2px;">
                                                Other
                                            </span>
                                        </mat-radio-button>
                                    </mat-radio-group>
                                    <mat-error *ngIf="isSubmitClicked && stocktakeForm.get('UserType').invalid">
                                        Required
                                    </mat-error>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <mat-form-field floatLabel="always" *ngIf="stocktakeForm.get('UserType').value == appConstants.hmca" style="width:100%">
                                        <mat-select formControlName="User" class="required"
                                                    (selectionChange)="setUserName()">
                                            <mat-option>
                                                <ngx-mat-select-search [placeholderLabel]="'Find Users...'"
                                                                       [noEntriesFoundLabel]="'no matching user found'"
                                                                       [formControl]="userFilter">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            <mat-option *ngFor="let user of filteredUsers | async" [value]="user">
                                                {{user.UserName}} - ({{user.DomainUserID}})
                                            </mat-option>
                                        </mat-select>
                                        <mat-placeholder>Select User <span style="color:red;">*</span></mat-placeholder>
                                        <mat-error *ngIf="isSubmitClicked && stocktakeForm.get('User').invalid">
                                            Required
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-form-field floatLabel="always" *ngIf="stocktakeForm.get('UserType').value == appConstants.other" style="width:100%">
                                        <input type="text" matInput placeholder="User:" formControlName="UserName"
                                               (blur)="setPrintName()"
                                               [required]="stocktakeForm.get('UserType').value == appConstants.other" />
                                        <mat-error *ngIf="isSubmitClicked && stocktakeForm.get('UserName').invalid">
                                            Required
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" *ngIf="stocktakeForm.get('UserType').value == appConstants.other">
                                    <mat-form-field floatLabel="always" style="width:100%">
                                        <input type="text" matInput placeholder="Organization:" formControlName="Organization"
                                               [required]="stocktakeForm.get('UserType').value == appConstants.other" />
                                        <mat-error *ngIf="isSubmitClicked && stocktakeForm.get('Organization').invalid">
                                            Required
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="container-fluid mt-2" formArrayName="modelDetails" style="padding-left:0px">
                                <ol class="list-style">
                                    <li class="mb-2" *ngFor="let item of stocktakeForm.get('modelDetails')['controls'] let itemIndex = index ">
                                        <div class="row m-1 p-2 border border-secondary rounded" [formGroupName]="itemIndex">
                                            <div class="row col-12">
                                                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                    <mat-form-field style="width:100%;" floatLabel="always">
                                                        <input type="text" matInput placeholder="Rego No:" formControlName="RegoNumber" required maxlength="10"
                                                               (change)="validateRegoNumber(item.controls.RegoNumber.value,itemIndex)" />
                                                        <mat-error *ngIf="isSubmitClicked">
                                                            Required
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="row col-12 pt-1">
                                                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                                    <mat-form-field style="width:100%;" floatLabel="always">
                                                        <input type="text" matInput placeholder="Model:" formControlName="Model" required />
                                                        <mat-error *ngIf="isSubmitClicked">Required</mat-error>
                                                    </mat-form-field>
                                                </div>
                                                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                                    <mat-form-field style="width:100%;" floatLabel="always">
                                                        <input type="text" matInput placeholder="DSN:" formControlName="DSN" maxlength="10"
                                                               (keypress)="numberOnly($event)" />
                                                        <mat-error *ngIf="isSubmitClicked">Required</mat-error>
                                                    </mat-form-field>
                                                </div>
                                                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                                    <mat-form-field style="width:100%;" floatLabel="always">
                                                        <input type="text" matInput placeholder="VIN:" formControlName="VIN" maxlength="17" />
                                                        <mat-error *ngIf="isSubmitClicked">Required</mat-error>
                                                    </mat-form-field>
                                                </div>
                                                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                                    <mat-form-field style="width:100%;" floatLabel="always">
                                                        <input type="text" matInput placeholder="KM:" formControlName="KM" required (keypress)="numberOnly($event)" />
                                                        <mat-error *ngIf="isSubmitClicked && item.controls.KM.hasError('required')">Required</mat-error>
                                                        <mat-error *ngIf="isSubmitClicked && item.controls.KM.hasError('min')">Should be greater than 0</mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="poll-btn">
                                            <button type="button" mat-icon-button mat-mini-fab color="warn"
                                                    matTooltip="Delete Vehicle" matTooltipPosition="above"
                                                    (click)="deleteModelDetails(itemIndex)"
                                                    [disabled]="stocktakeForm.get('modelDetails')['controls'].length == 1">
                                                <i class="material-icons">delete</i>
                                            </button>
                                        </div>
                                    </li>
                                </ol>
                                <div class="row col-12">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-2">
                                        <button mat-raised-button class="btn btn-primary" type="button" title="Add Vehicle" (click)="addNewModel()">
                                            Add Vehicle
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row pt-2">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div class="row">
                                        <div class="col-12">
                                            <mat-form-field style="width:100%;" floatLabel="always">
                                                <input type="text" matInput placeholder="Print Name:" formControlName="PrintName" required />
                                                <mat-error *ngIf="isSubmitClicked && stocktakeForm.get('PrintName').invalid">
                                                    Required
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-12 signatureFont">
                                            {{stocktakeForm.get('PrintName').value}}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <hr />
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <span>
                                        <mat-checkbox formControlName="IsAcknowledge" required class="pr-1">
                                        </mat-checkbox>
                                        I, <u>{{stocktakeForm.get('UserName').value}}</u> declare that I am in possession of the described vehicle/s listed above and that the vehicle is in good working order.
                                    </span>
                                    <br />
                                    <span class="text-danger" *ngIf="isSubmitClicked && stocktakeForm.get('IsAcknowledge').value== false">
                                        Please acknowledge
                                    </span>
                                </div>
                            </div>
                            <div class="row mt-2" *ngIf="isSubmitClicked && stocktakeForm.invalid">
                                <div class="col">
                                    <span class="text-danger"> Please fill all the required details</span>
                                </div>
                            </div>
                            <div class="row mt-2 mb-3">
                                <div class="col text-center">
                                    <button mat-raised-button class="btn btn-success" type="submit" (click)="onSubmit(stocktakeForm, formDirective)"> Submit {{url == routerConstants.Stocktake ? 'Stocktake' : 'FBT Declaration'}} </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </mat-card-content>

            </mat-card>
            <!--<app-credential-dialog *ngIf="showCredentialModal"
                                   (onSubmit)="handleCredentials($event)"
                                   (onCancel)="clearRadioSelection()">
            </app-credential-dialog>-->
        </div>
    </div>
</div>
